import React from 'react';
import style from './transactionHistoryModal.module.scss';
import { AppState } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import { closeModalByGoingBackIfPossibleFallingBackToUrl, Modal } from '../common/modal';
import { PresentationComponentBase } from '../presentationComponentBase';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { LoginRequiredModal } from '../auth/loginRequiredModal';
import { LoyaltyTransaction } from 'acscp/api/models/loyaltyTransaction';
import { Dispatch } from 'redux';
import { FetchRequest } from 'acscp/actions';
import { TransactionHistoryRequest } from 'acscp/api/requests/transactionHistoryRequest';
import { RequestClass } from 'acscp/api/requests';
import { RequestStateProps } from '../common/helpers/requestStateProps';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import classNames from 'classnames';
import modalStyle from '../common/modal.module.scss';

interface TransactionHistoryModalStateProps {
    isLoggedIn: boolean;
    transactionsRequestState: RequestStateProps;
    transactions: LoyaltyTransaction[];
}

interface TransactionHistoryDispatchProps {
    fetchTransactions: () => void;
}

class TransactionHistoryModalPresentational
        extends PresentationComponentBase<{}, TransactionHistoryModalStateProps, TransactionHistoryDispatchProps, {}> {

    componentDidMount(): void {
        this.props.fetchTransactions();
    }

    render(): JSX.Element {
        if (!this.props.isLoggedIn) {
            return <LoginRequiredModal closeUrl={'/loyalty'} />;
        }

        return (
            <Modal
                modalHeaderContent={
                    <FormattedMessage
                        id={'components.loyalty.transactionHistoryModal.modalHeader'}
                        defaultMessage={'TRANSACTION HISTORY'}
                    />}
                isOpen={true}
                closeModal={closeModalByGoingBackIfPossibleFallingBackToUrl('/loyalty')}
                modalClassName={style.modal}
                modalBodyClassName={style.ModalBody}
                closingModalClassName={style.Cross}
                modalHeaderClassName={style.ModalHeader}
                overlayClassName={style.Overlay}
            >
                <ul className={style.transactionsList}>
                    <li className={classNames(style.headersRow, style.tableRow)}>
                        <div className={style.transactionDateColumn}>
                            <FormattedMessage
                                id={'components.loyalty.transactionHistoryModal.dateHeader'}
                                defaultMessage={'Date'}
                            />
                        </div>
                        <div className={style.transactionActivityColumn}>
                            <FormattedMessage
                                id={'components.loyalty.transactionHistoryModal.activityHeader'}
                                defaultMessage={'Activity'}
                            />
                        </div>
                        <div className={style.transactionPointsEarnedColumn}>
                            <FormattedMessage
                                id={'components.loyalty.transactionHistoryModal.pointsEarnedHeader'}
                                defaultMessage={'Points Earned'}
                            />
                        </div>
                        <div className={style.transactionPointsDeductedColumn}>
                            <FormattedMessage
                                id={'components.loyalty.transactionHistoryModal.pointsDeductedHeader'}
                                defaultMessage={'Points Deducted'}
                            />
                        </div>
                        <div className={style.transactionValueColumn}>
                            <FormattedMessage
                                id={'components.loyalty.transactionHistoryModal.valueHeader'}
                                defaultMessage={'Value'}
                            />
                        </div>
                        <div className={style.transactionTotalColumn}>
                            <FormattedMessage
                                id={'components.loyalty.transactionHistoryModal.totalHeader'}
                                defaultMessage={'Total'}
                            />
                        </div>
                    </li>
                    {this.props.transactions.map((transaction, index) =>
                        <li key={index} className={style.tableRow}>
                            <div className={style.transactionDateColumn}>
                                {transaction.date}
                            </div>
                            <div className={style.transactionActivityColumn}>
                                {transaction.activity}
                            </div>
                            <div className={style.transactionPointsEarnedColumn}>
                                {transaction.pointsChange >= 0 && transaction.pointsChange}
                            </div>
                            <div className={style.transactionPointsDeductedColumn}>
                                {transaction.pointsChange < 0 && -transaction.pointsChange}
                            </div>
                            <div className={style.transactionValueColumn}>
                                {transaction.pointsChange}
                            </div>
                            <div className={style.transactionTotalColumn}>
                                {transaction.total}
                            </div>
                        </li>
                    )}
                </ul>
            </Modal>
        );
    }
}

function mapStateToProps(
    state: AppState,
    ownProps: {},
    getRequestError: (request: RequestClass<any>) => RequestStateProps
): TransactionHistoryModalStateProps {
    const isLoggedIn = userIsLoggedIn(state.auth);
    const transactionsRequestState = getRequestError(TransactionHistoryRequest);
    const transactions = state.loyaltyTransactions.transactions;

    return { isLoggedIn, transactionsRequestState, transactions };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): TransactionHistoryDispatchProps {
    return {
        fetchTransactions: () => dispatch(new FetchRequest(new TransactionHistoryRequest()))
    };
}

export const TransactionHistoryModal = connectWithRequests(mapStateToProps, mapDispatchToProps)(TransactionHistoryModalPresentational);
